export const modal = {
  modifyTitle: "MODIFICAR RESERVA",
  createTitle: "CREAR RESERVA",
  modifyAction: "Modificar reserva",
  createAction: "Crear reserva",
  processing: "Procesando reserva...",

  selectRoomType: "Seleccione tipo de habitación",
  selectAccommodation: "Seleccione un alojamiento",

  quantity: "Cantidad",
  arrival: "Llegada",
  departure: "Salida",
  guestName: "Nombre del huésped",
  email: "Email",
  phone: "Teléfono",
  guestsNumber: "Número de huéspedes",
  price: "Precio",
  cancel: "Cancelar",

  noTemplateSummary: "Sin Plantilla activa",
  noTemplateDetail: "No hay Plantilla",

  limitReachedSummary: "Límite alcanzado",
  limitPromotionDetail: "No puedes agregar más de 1 promoción",
  limitTaxDetail: "No puedes agregar más de 1 impuesto",

  validations: {
    fillRequired: "Por favor, complete todos los campos obligatorios.",
    phoneMin: "El número de teléfono debe tener al menos 5 dígitos.",
    selectDates: "Por favor, seleccione las fechas de llegada y salida.",
    guestsMin: "El número de huéspedes debe ser al menos 1.",
    priceNegative: "El precio no puede ser negativo.",
  },
};

export default modal;
